var _rect, _path, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorageArray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 2.667,
    width: 20,
    height: 16,
    rx: 1,
    transform: "rotate(90 20 2.667)",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 17.667h16M4 12.667h16M4 7.667h16",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 5.167,
    r: 0.75,
    fill: "currentColor"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 10.167,
    r: 0.75,
    fill: "currentColor"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 15.167,
    r: 0.75,
    fill: "currentColor"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 20.167,
    r: 0.75,
    fill: "currentColor"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMjAiIHk9IjIuNjY2NjciIHdpZHRoPSIyMCIgaGVpZ2h0PSIxNiIgcng9IjEiIHRyYW5zZm9ybT0icm90YXRlKDkwIDIwIDIuNjY2NjcpIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik00IDE3LjY2NjdIMjAiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNCAxMi42NjY3SDIwIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTQgNy42NjY2N0gyMCIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxjaXJjbGUgY3g9IjE3LjUiIGN5PSI1LjE2NjY3IiByPSIwLjc1IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPGNpcmNsZSBjeD0iMTcuNSIgY3k9IjEwLjE2NjciIHI9IjAuNzUiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8Y2lyY2xlIGN4PSIxNy41IiBjeT0iMTUuMTY2NyIgcj0iMC43NSIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxjaXJjbGUgY3g9IjE3LjUiIGN5PSIyMC4xNjY3IiByPSIwLjc1IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";
export { SvgStorageArray as ReactComponent };